module.exports = __webpack_public_path__ + "static/img/1-1.ba8adf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/eng/1-1.png
// module id = r9Jv
// module chunks = 0